import { Component, OnInit } from '@angular/core';
import { UrlService } from 'src/app/services/url.service';

@Component({
  selector: 'app-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.css']
})
export class StartComponent implements OnInit {

  constructor(
    private url: UrlService
  ) { }

  ngOnInit() {

  }

  goToPage(link: any) {
    this.url.getWindow().open(link, '_self')
  }


}
